export const LOCATION_NOTE_MARKER = '◆';

const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const isBlankNoteHtml = (html?: string): boolean =>
  !html || html.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim().length === 0;

// Append each stop's location note to the human note. The note is user-owned free text, so nothing is ever
// stripped back out: changing a location appends the new note and leaves the old one for the user to remove.
export const buildCarrierNoteWithLocationBlock = (
  humanNote: string | undefined,
  stops: { name?: string; locationNote?: string }[],
): string => {
  const base = humanNote || '';

  const notedStops = (stops || []).filter(stop => !isBlankNoteHtml(stop.locationNote));
  if (notedStops.length === 0) return base;

  const block = notedStops
    .map(stop => `<p>${LOCATION_NOTE_MARKER} <strong>${escapeHtml(stop.name || '')}</strong>:</p>${stop.locationNote}`)
    .join('');

  return `${base}${block}`;
};
